import moment from 'moment'
import { get, has } from 'lodash'

export function determinations({ subscription, isBacker, preOrderBackerStage, permits }) {
  const exists = subscription !== null && typeof subscription !== 'undefined'
  const periodEndAt = get(subscription, ['periodEndAt'])
  const status = get(subscription, ['status'])
  const lastPaymentFailedAt = get(subscription, ['lastPaymentFailedAt'])
  const paymentUpdatedAt = get(subscription, ['paymentUpdatedAt'])
  const isBraintree = get(subscription, ['type'], false) === 'braintree'
  const isComped = get(subscription, ['type'], false) === 'comped'
  const isEmployee = get(subscription, ['type'], false) === 'employee'
  const isFree = get(subscription, ['type'], false) === 'free'
  const isPaypal = get(subscription, ['type'], false) === 'paypal'
  const isPro = !isFree
  const isStripe = get(subscription, ['type'], false) === 'stripe'
  const isSeatUpgradeable = isStripe || isBraintree
  const isFa6Upgradeable = (isStripe || isBraintree) && get(subscription, ['discounts'], []).length === 0
  const active = get(subscription, ['status']) === 'active'
  const ended = !!get(subscription, ['endedAt'])
  const cancelAtPeriodEnd = get(subscription, ['cancelAtPeriodEnd'], false)
  const withinRenewalGracePeriod = get(subscription, ['withinRenewalGracePeriod'], false)
  const withinEndingGracePeriod = get(subscription, ['withinEndingGracePeriod'], false)
  const renewingSoon = active && !cancelAtPeriodEnd && withinRenewalGracePeriod
  const pastDue = status === 'past_due' || (periodEndAt && moment().isAfter(moment(periodEndAt)))
  const paymentFailed = !!lastPaymentFailedAt
  const paymentUpdated = !!paymentUpdatedAt
  const updatedPaymentAfterFailure = !lastPaymentFailedAt || !paymentUpdatedAt ? false : moment(lastPaymentFailedAt).isBefore(moment(paymentUpdatedAt))
  const paymentOnFile = get(subscription, ['paymentOnFile'], false)
  const updatedPeriod = moment(lastPaymentFailedAt).isBefore(moment(periodEndAt))
  const hasActivePaidSubscription = exists && active && !isFree
  const hasActiveProOnlySubscription = hasActivePaidSubscription && has(permits, ['yep', 'accessToPro']) && !has(permits, ['yep', 'accessToProPlus'])
  const hasActiveProOnlySubscriptionWithDownload =
    hasActivePaidSubscription && has(permits, ['yep', 'accessToProDownload']) && !has(permits, ['yep', 'accessToProPlusDownload'])
  const hasActiveProPlusSubscription = hasActivePaidSubscription && has(permits, ['yep', 'accessToProPlus'])
  const hasActiveProPlusSubscriptionWithDownload = hasActivePaidSubscription && has(permits, ['yep', 'accessToProPlusDownload'])

  let indication = 'normal'

  if (!subscription && !isBacker) {
    indication = 'useless'
  }

  if (renewingSoon) {
    indication = 'info'
  }

  if (renewingSoon && !paymentOnFile) {
    indication = 'warning'
  }

  if (withinRenewalGracePeriod && cancelAtPeriodEnd) {
    indication = 'warning'
  }

  if (!cancelAtPeriodEnd && paymentFailed && !updatedPaymentAfterFailure) {
    indication = 'danger'
  }

  return {
    exists,
    hasActivePaidSubscription,
    hasActiveProOnlySubscription,
    hasActiveProOnlySubscriptionWithDownload,
    hasActiveProPlusSubscription,
    hasActiveProPlusSubscriptionWithDownload,
    indication,
    isBacker,
    preOrderBackerStage: isBacker && !exists ? preOrderBackerStage : undefined,
    isBraintree,
    isComped,
    isEmployee,
    isFree,
    isPaypal,
    isPro,
    isStripe,
    isSeatUpgradeable,
    isFa6Upgradeable,
    active,
    ended,
    cancelAtPeriodEnd,
    withinRenewalGracePeriod,
    withinEndingGracePeriod,
    renewingSoon,
    pastDue,
    paymentFailed,
    paymentUpdated,
    paymentOnFile,
    updatedPaymentAfterFailure,
    updatedPeriod
  }
}
